import React from 'react'

class ShopErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, message: '' }
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      message: error?.message ? String(error.message) : 'Unexpected error',
    }
  }

  componentDidCatch(error, info) {
    console.error('[ShopErrorBoundary] Shop panel crashed:', error, info)
  }

  handleTryAgain = () => {
    this.setState({ hasError: false, message: '' })
    if (typeof this.props.onReset === 'function') {
      this.props.onReset()
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <section
        role="alert"
        aria-live="assertive"
        className="shop-error-boundary card"
        style={{
          margin: 'var(--space-4) auto',
          maxWidth: '820px',
          border: '1px solid var(--color-rose-200, #fecdd3)',
          background: 'var(--color-rose-50, #fff1f2)',
        }}
      >
        <div className="shop-card-body">
          <h2 className="shop-list-heading" style={{ marginTop: 0 }}>Shop is temporarily unavailable</h2>
          <p className="page-subtitle" style={{ marginBottom: 'var(--space-3)' }}>
            Couldn’t load your list.
          </p>
          {this.state.message && (
            <p
              style={{
                fontSize: 'var(--text-sm)',
                color: 'var(--color-rose-700, #be123c)',
                marginBottom: 'var(--space-3)',
              }}
            >
              Error: {this.state.message}
            </p>
          )}
          <button
            type="button"
            className="chat-send-btn"
            onClick={this.handleTryAgain}
            aria-label="Try loading Shop again"
          >
            Try again
          </button>
        </div>
      </section>
    )
  }
}

export default ShopErrorBoundary
